
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.854 2.823H25.207v6.53h20.647v-6.53zM45.679 13.412v-.706h-20.47V33.176c0 .353-.177.706-.53 1.06-2.294 1.764-4.589 3.529-6.706 5.294-5.647 4.411-5.118 13.058 1.765 16.764 3.705 1.941 7.411 1.412 10.764-1.059 4.941-3.706 9.706-7.411 14.647-11.117.353-.353.53-.53.53-1.06V13.413zM22.914 54.353c-3-.53-4.765-2.47-5.647-5.294-.706-2.47-.177-4.765 1.765-6.883 3.529 3.53 6.882 6.883 10.235 10.412-1.765 1.588-3.883 2.294-6.353 1.765zM42.855 42c0 .176-.176.353-.353.53a302.591 302.591 0 00-4.412 3.352c-.882-1.764-1.058-3.706-.353-5.647.883-2.47 2.648-3.882 5.118-4.764V42zm-.53-9.176c-6.352 1.588-9.529 8.294-6.705 14.294 0 .176.176.353.176.53l-4.235 3.176-10.412-10.412c.883-.706 1.941-1.412 2.824-2.294 1.059-.883 2.294-1.765 3.353-2.647a.97.97 0 00.53-.883V23.824 18v-2.472h14.823V31.942c.176.53.176.706-.353.883z","fill":"#fff"}})])
          )
        }
      }
    